module.exports = __webpack_public_path__ + "static/media/view1.92a07c08.jpeg";